import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SteponeactivitiesComponent } from '../../../../../components/activities/steponeactivities/steponeactivities.component';
import { SteptwoactivitiesComponent } from '../../../../../components/activities/steptwoactivities/steptwoactivities.component';
import { StepthreeactivitiesComponent } from '../../../../../components/activities/stepthreeactivities/stepthreeactivities.component';
import { StepfouractivitiesComponent } from '../../../../../components/activities/stepfouractivities/stepfouractivities.component';
import { CommonModule } from '@angular/common';
import { RecapactivitiesComponent } from '../../../../../components/activities/recapactivities/recapactivities.component';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { MatIcon } from '@angular/material/icon';
import { SelectComponent } from '../../../../../components/forms/select/select.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { RegroupementActiviteRes } from '../../../../../data/http/responses/regroupementactivities.res';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { AppService } from '../../../../../core/app.service';
import { LigneBudgetaireService } from '../../../../../services/lignebudgetaire/lignebudgetaire.service';
import { StructureService } from '../../../../../services/StructureService';
import { ActiviteService } from '../../../../../services/activite/activite.service';
import { RegroupementActiviteService } from '../../../../../services/regroupementactivities.service';
import { StepperState } from '../../activity/add/add.component';
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { LigneBudgetaireResponse } from '../../../../../data/http/responses/lignebudgetaire.res';
import { ActivtieResponse } from '../../../../../data/http/responses/activite.response';
import { toCamelCase, toSnakeCaseUpper } from '../../../../../utils/helpers';
import { routeAlias } from '../../../../../../routesalias';

@Component({
  selector: 'app-edit',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SteponeactivitiesComponent,
    SteptwoactivitiesComponent,
    StepthreeactivitiesComponent,
    StepfouractivitiesComponent,
    CommonModule,
    RecapactivitiesComponent,
    LoaderComponent,
    MatIcon,
    SelectComponent,
    RouterLink
  ],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.css'
})
export class EditRegroupementActivity implements OnInit, OnDestroy {

  baseSteps = [
    { id: 'generales', label: 'Informations Générales' },
    { id: 'activites', label: "Informations sur l'Activités" },
    { id: 'budgets',   label: "Informations sur le budget de l'activité" },
    { id: 'recap',     label: 'Récapitulatif' }
  ];
  steps: { id: string; label: string }[] = [];

  activeStepId: string = '';
  activity: any = {
    generales: { typeInterventionSelect: '', typeActivitySelect: '' },
    activites: {},
    budgets: {},
    stepfour: {}
  };

  public showPmpStep: boolean = false;
  private isTypeNouvelleActivite: boolean = false;
  private isModePmp: boolean = false;
  public completedSteps: string[] = [];
  private pendingRegroupOptions: SelectOption[] = [];
  public activityId: string | null = '';

  private queryParamsSubscription: Subscription | undefined;
  private readonly stepperStateKey = 'activityStepperState';
  private readonly activityDataKey  = 'activity';

  public isLoading: boolean = false;
  public entities: RegroupementActiviteRes[] = [];
  public entityForm: FormGroup = new FormGroup({});
  public structureData: SelectOption[] = [];
  public ligneBudgetaires: SelectOption[] = [];
  public activities: SelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private AppService: AppService,
    private ligneBudgetaireService: LigneBudgetaireService,
    private structureService: StructureService,
    private activiteService: ActiviteService,
    private regroupementActiviteService: RegroupementActiviteService
  ) {
    this.entityForm = this.fb.group({
      activitesSelectionnees: this.fb.array([]),
      applicationId: this.AppService.getAppId()!,
      complementaryInfo: this.fb.group({})
    });
  }

  // ═══════════════════════════════════════════════
  // LIFECYCLE
  // ═══════════════════════════════════════════════

  ngOnInit(): void {
    this.activityId = this.route.snapshot.paramMap.get('id');

    if (this.activityId) {
      this.isLoading = true;
      this.activiteService.getById(this.activityId).subscribe({
        next: (response) => {
          this.activity = this.transformApiDataToActivityState(response.data);

          this.pendingRegroupOptions = Array.isArray(response?.data?.regroupements)
            ? response.data.regroupements.map((item: any) => ({
                value: item.id,
                label: item.titre ?? item.label ?? item.libelle ?? ''
              }))
            : [];

          localStorage.setItem(this.activityDataKey, JSON.stringify(this.activity));
          this.initializeStepperStateForEdit(response.data);

          this.loadActivities();
          this.loadLigneBudgetaire();
          this.loadStructures();
          this.setupStepperNavigation();
          this.isLoading = false;
        },
        error: (err) => {
          console.error("Erreur lors du chargement de l'activité", err);
          this.isLoading = false;
        }
      });
    } else {
      console.error("Aucun ID d'activité fourni.");
      this.loadActivities();
      this.loadLigneBudgetaire();
      this.loadStructures();
      this.initializeDefaultStepperState();
      this.setupStepperNavigation();
    }
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
  }

  // ═══════════════════════════════════════════════
  // STEPPER
  // ═══════════════════════════════════════════════

  getActiveStepIndex(): number {
    return this.steps.findIndex(s => s.id === this.activeStepId);
  }

  getProgressPercent(): number {
    const total = this.steps.length;
    if (total <= 1) return 0;
    return Math.round((this.getActiveStepIndex() / (total - 1)) * 100);
  }

  private setupStepperNavigation(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      const requestedStepId = params['step'];

      // En mode édition le stepper est toujours actif dès l'init
      const currentStepIndex = this.steps.findIndex(s => s.id === requestedStepId);

      const isRecapAvailable = requestedStepId === 'recap' &&
        ((!this.showPmpStep && this.completedSteps.includes('budgets')) ||
          (this.showPmpStep && this.completedSteps.includes('stepfour')));

      if (requestedStepId && currentStepIndex !== -1) {
        const isStepAvailable =
          this.completedSteps.includes(requestedStepId) ||
          requestedStepId === this.activeStepId ||
          isRecapAvailable;

        if (isStepAvailable) {
          this.activeStepId = requestedStepId;
        } else {
          this.router.navigate([], {
            queryParams: { step: this.activeStepId },
            relativeTo: this.route,
            replaceUrl: true
          });
        }
      } else {
        this.router.navigate([], {
          queryParams: { step: this.activeStepId },
          relativeTo: this.route,
          replaceUrl: true
        });
      }

      this.saveStepperState();
    });
  }

  private initializeStepperStateForEdit(apiData: any): void {
    this.isTypeNouvelleActivite = this.activity.generales?.typeActivitySelect === 'Nouvelle activité';
    this.isModePmp = this.activity.activites?.modeExecution === 'PMP' || Object.keys(this.activity.stepfour).length > 0;
    this.showPmpStep = this.isTypeNouvelleActivite && this.isModePmp;
    this.updateStepsArray();

    // En édition toutes les étapes sont accessibles
    this.completedSteps = this.steps.map(s => s.id);

    const initialStepFromUrl = this.route.snapshot.queryParams['step'];
    this.activeStepId = (initialStepFromUrl && this.steps.some(s => s.id === initialStepFromUrl))
      ? initialStepFromUrl
      : (this.steps[0]?.id || 'generales');

    this.saveStepperState();
  }

  private initializeDefaultStepperState(): void {
    this.activity = {
      generales: { typeInterventionSelect: '', typeActivitySelect: '' },
      activites: {},
      budgets: {},
      stepfour: {}
    };
    this.activeStepId = 'generales';
    this.completedSteps = [];
    this.isTypeNouvelleActivite = false;
    this.isModePmp = false;
    this.showPmpStep = false;
    this.updateStepsArray();
    this.saveStepperState();
  }

  private updateStepsArray(): void {
    this.steps = [...this.baseSteps];
    if (this.showPmpStep) {
      const recapIndex = this.steps.findIndex(s => s.id === 'recap');
      if (recapIndex !== -1) {
        this.steps.splice(recapIndex, 0, { id: 'stepfour', label: 'Informations Marché' });
      } else {
        this.steps.push({ id: 'stepfour', label: 'Informations Marché' });
      }
    }
  }

  private saveStepperState(): void {
    const state: StepperState = {
      activeStepId:   this.activeStepId,
      completedSteps: this.completedSteps,
      showPmpStep:    this.isTypeNouvelleActivite && this.isModePmp
    };
    localStorage.setItem(this.stepperStateKey, JSON.stringify(state));
  }

  // ═══════════════════════════════════════════════
  // FORM ARRAY
  // ═══════════════════════════════════════════════

  get activitesFormArray(): FormArray {
    return this.entityForm.get('activitesSelectionnees') as FormArray;
  }

  get complementaryInfoFormGroup(): FormGroup {
    return this.entityForm.get('complementaryInfo') as FormGroup;
  }

  addActivity(): void {
    this.activitesFormArray.push(this.fb.control('', Validators.required));
    this.checkStepperActivation();
  }

  removeActivity(index: number): void {
    if (this.activitesFormArray.length > 1) {
      this.activitesFormArray.removeAt(index);
      this.checkStepperActivation();
    }
  }

  getAvailableActivities(index: number): SelectOption[] {
    const selectedIds = this.activitesFormArray.value as string[];
    const currentId   = this.activitesFormArray.at(index).value as string;
    return this.activities.filter(a => !selectedIds.includes(a.value) || a.value === currentId);
  }

  private checkStepperActivation(): void {
    if (this.activitesFormArray.length >= 2) {
      if (!this.activeStepId) {
        this.activeStepId = this.baseSteps[0].id;
        this.updateStepsArray();
        this.completedSteps = [];
        this.saveStepperState();
        // ✅ Navigation explicite pour déclencher le queryParamsSubscription
        this.router.navigate([], {
          queryParams: { step: this.activeStepId },
          relativeTo: this.route
        });
      }
    } else {
      this.activeStepId = '';
      this.steps = [];
      this.completedSteps = [];
      this.saveStepperState();
      this.router.navigate([], {
        queryParams: {},
        relativeTo: this.route,
        replaceUrl: true
      });
    }
  }

  // ═══════════════════════════════════════════════
  // CHARGEMENT DES DONNÉES
  // ═══════════════════════════════════════════════

  loadStructures(): void {
    this.structureService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.structureData = response.data.map((item: StructureResponse) => ({
          value: item.code,
          label: item.code
        }));

        if (this.pendingRegroupOptions?.length) {
          this.pendingRegroupOptions.forEach(opt => {
            if (!this.activities.some(a => a.value === opt.value)) {
              this.activities.push(opt);
            }
          });

          this.pendingRegroupOptions.forEach(opt => {
            this.activitesFormArray.push(this.fb.control(opt.value, Validators.required));
          });

          this.entityForm.patchValue({
            activitesSelectionnees: this.activitesFormArray.value
          });

          this.pendingRegroupOptions = [];
        }
      },
      error: (err) => console.error('Erreur structures :', err)
    });
  }

  loadLigneBudgetaire(): void {
    this.ligneBudgetaireService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.ligneBudgetaires = response.data.map((item: LigneBudgetaireResponse) => ({
          value: item.libelle,
          label: item.libelle
        }));
      },
      error: (err) => console.error('Erreur lignes budgétaires :', err)
    });
  }

  loadActivities(): void {
    this.activiteService.getAllByAppIdExcludeRegroupement(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.activities = response.data.map((item: ActivtieResponse) => ({
          value: item.id,
          label: item.titre
        }));
      },
      error: (err) => console.error('Erreur activités :', err)
    });
  }

  // ═══════════════════════════════════════════════
  // TRANSFORMATION API → STATE
  // ═══════════════════════════════════════════════

  private transformApiDataToActivityState(data: any): any {
    const activityState: any = {
      generales: { taches: [] },
      activites: { structureAssociee: [] },
      budgets: {},
      stepfour: {}
    };

    activityState.generales.typeInterventionSelect = data.parent?.id || '';
    activityState.generales.activities             = data.titre || '';
    activityState.generales.description            = data.objectif || '';

    let isModePmpFromData = false;

    data.caracteristiques.forEach((car: { code: string; valeur: any }) => {
      const key = toCamelCase(car.code);
      switch (key) {
        case 'typeActivite':
          activityState.generales.typeActivitySelect = car.valeur;
          break;
        case 'supervisor':
        case 'structureResponsable':
          activityState.activites[key] = car.valeur;
          break;
        case 'modeExecution':
          activityState.activites[key] = car.valeur;
          if (car.valeur === 'PMP') isModePmpFromData = true;
          break;
        case 'structassocie':
          activityState.activites.structureAssociee.push(car.valeur);
          break;
        case 'montantEstimatif':
        case 'imputationBudgetaire':
        case 'horizon':
        case 'coutPrevuN':
        case 'coutPrevuN1':
        case 'previsionDecaissementT4N':
        case 'previsionDecaissementN2':
        case 'montantDecaisseAu30SeptN':
        case 'encaissementEstimatif':
        case 'decaissementEstimatif':
          activityState.budgets[key] = car.valeur;
          break;
        case 'delaiNeccessairePassationMarche':
        case 'dureePrevisionExecutionMarche':
        case 'echeanceSatisfaction':
        case 'modePassationMarche':
          activityState.stepfour[key] = car.valeur;
          break;
        default:
          activityState.stepfour[key] = car.valeur;
          break;
      }
    });

    const monthNamesMap: { [key: string]: number } = {
      JANVIER: 0, FEVRIER: 1, MARS: 2, AVRIL: 3, MAI: 4, JUIN: 5,
      JUILLET: 6, AOUT: 7, SEPTEMBRE: 8, OCTOBRE: 9, NOVEMBRE: 10, DECEMBRE: 11
    };

    if (data.taches && Array.isArray(data.taches)) {
      activityState.generales.taches = data.taches.map((tache: any) => {
        const formTache = {
          titreTache: tache.titre,
          poids: '',
          chronogrammes: Array(12).fill(false)
        };
        if (tache.caracteristiques) {
          tache.caracteristiques.forEach((car: { code: string; valeur: any }) => {
            if (car.code === 'POIDS') {
              formTache.poids = car.valeur;
            } else if (monthNamesMap[car.code] !== undefined) {
              formTache.chronogrammes[monthNamesMap[car.code]] = car.valeur === 'true' || car.valeur === true;
            }
          });
        }
        return formTache;
      });
    }

    this.isTypeNouvelleActivite = activityState.generales?.typeActivitySelect === 'Nouvelle activité';
    this.isModePmp = isModePmpFromData || Object.keys(activityState.stepfour).length > 0;

    return activityState;
  }

  // ═══════════════════════════════════════════════
  // COMMUNICATION PARENT ↔ ENFANTS
  // ═══════════════════════════════════════════════

  updateActivity(stepData: any, stepId: string): void {
    if (stepId === 'generales')      this.activity.generales = stepData;
    else if (stepId === 'activites') this.activity.activites = stepData;
    else if (stepId === 'budgets')   this.activity.budgets   = stepData;
    else if (stepId === 'stepfour')  this.activity.stepfour  = stepData;

    localStorage.setItem(this.activityDataKey, JSON.stringify(this.activity));

    if (!this.completedSteps.includes(stepId)) {
      this.completedSteps.push(stepId);
    }

    const currentStepIndex = this.steps.findIndex(s => s.id === stepId);
    if (currentStepIndex !== -1 && currentStepIndex < this.steps.length - 1) {
      const nextStepId = this.steps[currentStepIndex + 1].id;
      this.activeStepId = nextStepId;
      this.router.navigate([], { queryParams: { step: nextStepId }, relativeTo: this.route });
    } else if (currentStepIndex === this.steps.length - 1 && stepId !== 'recap') {
      const recapStep = this.steps.find(s => s.id === 'recap');
      if (recapStep) {
        this.activeStepId = 'recap';
        this.router.navigate([], { queryParams: { step: 'recap' }, relativeTo: this.route });
      }
    }

    this.saveStepperState();
  }

  handleTypeActivityChange(isNouvelleActivite: boolean): void {
    this.isTypeNouvelleActivite = isNouvelleActivite;
    this.updatePmpStepVisibility();
  }

  handlePmpModeChange(isPmp: boolean): void {
    this.isModePmp = isPmp;
    this.updatePmpStepVisibility();
  }

  private updatePmpStepVisibility(): void {
    const shouldShow = this.isTypeNouvelleActivite && this.isModePmp;
    if (this.showPmpStep === shouldShow) return;

    this.showPmpStep = shouldShow;
    this.updateStepsArray();

    if (!this.showPmpStep && this.activeStepId === 'stepfour') {
      this.activeStepId = 'budgets';
      this.activity.stepfour = {};
      localStorage.setItem(this.activityDataKey, JSON.stringify(this.activity));
      this.router.navigate([], {
        queryParams: { step: 'budgets' },
        relativeTo: this.route,
        replaceUrl: true
      });
    }

    this.saveStepperState();
  }

  // ═══════════════════════════════════════════════
  // SOUMISSION
  // ═══════════════════════════════════════════════

  handleFinalSubmit(): void {
    this.onSubmitActivity();
  }

  onSubmitActivity(): void {
    const caracteristiquesArray: { code: string; valeur: any }[] = [];

    const excludedFieldForActivites = ['structureAssociee'];
    Object.keys(this.activity.activites).forEach(key => {
      if (!excludedFieldForActivites.includes(key)) {
        caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.activites[key] ?? '' });
      }
    });

    if (Array.isArray(this.activity.activites.structureAssociee)) {
      this.activity.activites.structureAssociee.forEach((id: string) => {
        caracteristiquesArray.push({ code: 'STRUCTASSOCIE', valeur: id ?? '' });
      });
    }

    Object.keys(this.activity.budgets).forEach(key => {
      caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.budgets[key] ?? '' });
    });

    Object.keys(this.activity.stepfour).forEach(key => {
      caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.stepfour[key] ?? '' });
    });

    caracteristiquesArray.push({ code: 'TYPE_ACTIVITE', valeur: this.activity.generales.typeActivitySelect ?? '' });

    const monthNames = ['JANVIER','FEVRIER','MARS','AVRIL','MAI','JUIN','JUILLET','AOUT','SEPTEMBRE','OCTOBRE','NOVEMBRE','DECEMBRE'];
    const transformedTaches: any[] = [];

    if (Array.isArray(this.activity.generales.taches)) {
      this.activity.generales.taches.forEach((tache: any) => {
        const tacheCaracteristiques: { code: string; valeur: any }[] = [];
        if (tache.poids !== undefined) {
          tacheCaracteristiques.push({ code: 'POIDS', valeur: tache.poids ?? '' });
        }
        if (Array.isArray(tache.chronogrammes)) {
          tache.chronogrammes.forEach((isScheduled: boolean, index: number) => {
            if (index < monthNames.length) {
              tacheCaracteristiques.push({ code: monthNames[index], valeur: !!isScheduled });
            }
          });
        }
        transformedTaches.push({ titre: tache.titreTache ?? '', caracteristiques: tacheCaracteristiques });
      });
    }

    const trueSendingActivity = {
      parent:           this.activity.generales.typeInterventionSelect ?? '',
      titre:            this.activity.generales.activities ?? '',
      objectif:         this.activity.generales.description ?? '',
      typeActivite:     'ACTIVITE',
      caracteristiques: caracteristiquesArray,
      taches:           transformedTaches,
      applicationId:    this.AppService.getAppId()!,
      regroupements:    this.entityForm.value.activitesSelectionnees,
    };

    if (this.entityForm.valid && this.entityForm.value.activitesSelectionnees.length >= 2 && this.activity != null) {
      this.isLoading = true;
      this.regroupementActiviteService.create(trueSendingActivity).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate([routeAlias.activities.home, routeAlias.activities.activity.home]);
        },
        error: (err) => {
          console.error('Erreur lors de la modification :', err);
          this.isLoading = false;
        }
      });
    }
  }
}